import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {ChooseCardComponent} from "./components/ChooseCardComponent";
import {PayWithAddedCardComponent} from "./components/PayWithAddedCardComponent";
import {UsingCardComponent} from "./components/UsingCardComponent";

import {BasePanelPage} from "../BasePanelPage";
import {Messages} from "../../../../Messages";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {MerchantButton} from "../../../../common/MerchantButton";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {PanelToast} from "../../../PanelToast";
import {Device} from "../../../../../stem-core/src/base/Device";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {CARD_SECTION_STATE} from "../../../inline-donation/PaymentMethodController";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {iFrameState} from "../../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../../blink-sdk/Constants";
import {Controller} from "../../../Controller";


const CARD_SECTION_MAP = {
    [CARD_SECTION_STATE.chooseCard]: ChooseCardComponent,
    [CARD_SECTION_STATE.payWithAddedCard]: PayWithAddedCardComponent,
    [CARD_SECTION_STATE.usingCard]: UsingCardComponent,
    [CARD_SECTION_STATE.addCard]: PayWithAddedCardComponent,
};

export class PaymentMethodPanel extends BasePanelPage {
    getCardSectionState() {
        if ((!Controller.paymentMethod.initialPaymentMethod && !iFrameUserDataService.getExtraPaymentMethodCount())
            || iFrameMerchantService.isCDSPaymentMethod()) {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.payWithAddedCard;
        }
        return Controller.paymentMethod.cardSectionState;
    }

    render() {
        if (!Controller.paymentMethod.selectedPaymentMethod) {
            Controller.paymentMethod.selectedPaymentMethod = Controller.paymentMethod.getInitialPaymentMethod();
            Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.getInitialPaymentMethod();
        }

        const CardSectionClass = CARD_SECTION_MAP[this.getCardSectionState()];
        const onAddCard = () => {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.addCard;
            Router.updateURL();
        };

        return [
            <CardSectionClass card={Controller.paymentMethod.selectedPaymentMethod} className={this.styleSheet.cardComponent}
                              hideActiveCard={true} onChange={() => this.redraw()} onAddCard={onAddCard}
                              entry={Controller.paymentMethod.entry}
                              ref="cardComponent"/>,
            this.renderButtonSection(),
        ];
    }

    isButtonDisabled() {
        return !(this.cardComponent && this.cardComponent.isValid());
    }

    renderButtonSection() {
        const {styleSheet} = this;
        const cancelAddCard = () => {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
        };
        const giftSubscriptionMessage = iFrameState.panelType === PANEL_TYPE.giftSubscription ?
            <div>{Messages.giftPaymentMethodDescription}</div> : "";

        if (this.getCardSectionState() === CARD_SECTION_STATE.chooseCard ||
            this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard) {
            return [
                giftSubscriptionMessage,
                <MerchantButton ref="button" className={styleSheet.button} disabled={this.isButtonDisabled()}
                                label={this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard ?
                                    Controller.paymentMethod.getPayWithAddedCardButtonLabel() :
                                    Controller.paymentMethod.getChooseCardButtonLabel()}
                                onClick={() => this.continueWithChosenCard()} />,
                Device.isMobileDevice() ? null :
                <div className={styleSheet.center}>
                    <div className={styleSheet.secondaryButton} onClick={() => {
                            Controller.paymentMethod.onSelectCancel();
                        }}>
                        {Messages.back}
                    </div>
                </div>
            ];
        }
        return [
            giftSubscriptionMessage,
            <MerchantButton className={styleSheet.button} ref="button" label={Messages.continue}
                            onClick={() => this.addCard()} disabled={this.isButtonDisabled()}/>,
            <div className={styleSheet.center}>
                <div onClick={cancelAddCard} className={styleSheet.secondaryButton}>
                    {Messages.cancel}
                </div>
            </div>
        ];
    }

    continueWithChosenCard() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(Controller.paymentMethod.getScope(), preferredPaymentMethodId => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                Controller.paymentMethod.selectedPaymentMethod = preferredPaymentMethodId;
            } else {
                Controller.paymentMethod.selectedPaymentMethod = PaymentMethodStore.get(preferredPaymentMethodId);
            }

            Controller.paymentMethod.onSelectSuccess();
        }, error => {
            if (Controller.paymentMethod.cardSectionState === CARD_SECTION_STATE.chooseCard) {
                PanelToast.showError(error.message);
            }
            LoadingSpinner.hide();
        });
    }

    addCard() {
        LoadingSpinner.show();
        this.cardComponent.getPaymentMethodId(Controller.paymentMethod.getScope(), preferredPaymentMethodId => {
            Controller.paymentMethod.selectedPaymentMethod = PaymentMethodStore.get(preferredPaymentMethodId);
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
            LoadingSpinner.hide();
        }, () => LoadingSpinner.hide());
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
